import { toast } from 'react-toastify';

export const notify = (action, message) => {
    if (!toast.isActive(message)) {
        return toast[action](message, { toastId: message });
    }
};
